import axios, { AxiosResponse } from "axios";

const getBaseUrl = () =>
  (process.env.REACT_APP_MEMBER_APP_OIDC_AUTHORIRTY || "").replace(/\/$/, "");

const getAuthHeaders = () => {
  const token = localStorage.getItem("PortalAdmin-AccessToken");
  return {
    Authorization: token ? `Bearer ${token}` : "",
  };
};

/**
 * Browsers normalize path segments "." / ".." (and even "%2E%2E") to parent
 * directories, so FindUserByName/.. becomes /api/user/. Double-encode those
 * segments only; normal usernames like "john.doe" stay single-encoded.
 */
const encodePathSegment = (value: string) => {
  const trimmed = value.trim();
  if (trimmed === "." || trimmed === "..") {
    return trimmed.replace(/\./g, "%252E");
  }
  return encodeURIComponent(trimmed);
};

const handleFindUserResponse = (res: AxiosResponse) => {
  if (res.status === 204 || res.data == null || res.data === "") {
    return null;
  }
  return res.data;
};

export class LinkUserApi {
  static findUserByName(username: string) {
    const url = `${getBaseUrl()}/api/user/FindUserByName/${encodePathSegment(
      username,
    )}`;
    return axios
      .get(url, { headers: getAuthHeaders() })
      .then(handleFindUserResponse);
  }

  static findUserByEmail(email: string) {
    const url = `${getBaseUrl()}/api/user/FindUserByEmail/${encodePathSegment(
      email,
    )}`;
    return axios
      .get(url, { headers: getAuthHeaders() })
      .then(handleFindUserResponse);
  }

  static findUserById(ssoguid: string) {
    const url = `${getBaseUrl()}/api/user/FindUserById/${encodePathSegment(
      ssoguid,
    )}`;
    return axios
      .get(url, { headers: getAuthHeaders() })
      .then(handleFindUserResponse);
  }

  static getClientUserMapping(userId: string) {
    const url = `${getBaseUrl()}/api/user/GetClientUserMapping`;
    const body = {
      ClientName: process.env.REACT_APP_MEMBER_APP_OIDC_CLIENTID,
      UserId: userId,
    };
    return axios
      .post(url, body, {
        headers: {
          ...getAuthHeaders(),
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        if (res.status === 204 || res.data == null || res.data === "") {
          return null;
        }
        return res.data;
      });
  }

  static addClientUserMapping(payload: {
    UserId: string;
    ClientName: string | undefined;
    IsActive: boolean;
    CreatedById: string;
    CreatedBy: string;
  }) {
    const url = `${getBaseUrl()}/api/user/AddClientUserMapping`;
    return axios
      .post(url, payload, {
        headers: {
          ...getAuthHeaders(),
          "Content-Type": "application/json",
        },
      })
      .then((res) => res.data);
  }
}
